import { VanillaGame } from './vanilla';
import { Legacy1Game } from './legacy-1';
import { Legacy2Game } from './legacy-2';

export const games = [
    VanillaGame,
    Legacy1Game,
    Legacy2Game
];
